import React, { useEffect, useState } from 'react'
import { Grid, Typography } from '@material-ui/core'
import { useLocation } from 'react-router-dom'
import { ADMIN_TENANT_GET } from 'components/api'
import { SuperAdminNav } from './SuperAdminNav'
import { Breadcrumbs } from './Breadcrumbs'
import { getCachedTenantName, cacheTenantName } from '../tenantNameCache'
import '../superadmin.scss'

const TAB_LABELS = {
    overview: 'Overview',
    'client-apps': 'Client Apps',
    emails: 'Emails',
    surveys: 'Surveys',
    settings: 'Settings',
}

function buildCrumbs(pathname, tenantName) {
    const crumbs = [{ label: 'Superadmin', href: '/superadmin/system' }]

    if (pathname === '/superadmin/system' || pathname === '/superadmin') {
        crumbs.push({ label: 'System' })
        return crumbs
    }

    if (pathname === '/superadmin/users') {
        crumbs.push({ label: 'Users' })
        return crumbs
    }

    if (pathname === '/superadmin/tenants') {
        crumbs.push({ label: 'Tenants' })
        return crumbs
    }

    const tenantMatch = pathname.match(/^\/superadmin\/tenants\/([^/]+)(?:\/(.+))?$/)
    if (tenantMatch) {
        const tenantId = tenantMatch[1]
        const tab = tenantMatch[2]
        const name = tenantName || getCachedTenantName(tenantId) || tenantId

        crumbs.push({ label: 'Tenants', href: '/superadmin/tenants' })
        crumbs.push({
            label: name,
            href: tab ? `/superadmin/tenants/${tenantId}` : undefined,
        })

        if (tab && TAB_LABELS[tab]) {
            crumbs.push({ label: TAB_LABELS[tab] })
        }

        return crumbs
    }

    return crumbs
}

export function SuperAdminLayout({ children }) {
    const location = useLocation()
    const [tenantName, setTenantName] = useState(null)

    useEffect(() => {
        const tenantMatch = location.pathname.match(/^\/superadmin\/tenants\/([^/]+)/)
        if (!tenantMatch) {
            setTenantName(null)
            return
        }

        const tenantId = tenantMatch[1]
        const cached = getCachedTenantName(tenantId)
        if (cached) {
            setTenantName(cached)
            return
        }

        ADMIN_TENANT_GET(tenantId)
            .then(tenant => {
                const name = tenant?.tenant_details?.tenant_name || tenant?.tenant_name
                if (name) {
                    cacheTenantName(tenantId, name)
                    setTenantName(name)
                }
            })
            .catch(() => setTenantName(null))
    }, [location.pathname])

    const crumbs = buildCrumbs(location.pathname, tenantName)

    return (
        <div className="superadmin-page">
            <Typography variant="h5" style={{ marginBottom: 16 }}>
                Superadmin
            </Typography>
            <Grid container>
                <Grid item xs={12} md={2}>
                    <SuperAdminNav />
                </Grid>
                <Grid item xs={12} md={10}>
                    <div className="superadmin-content">
                        <Breadcrumbs crumbs={crumbs} />
                        {children}
                    </div>
                </Grid>
            </Grid>
        </div>
    )
}
